import { useVeltClient } from '@veltdev/react';
import React, { useEffect } from 'react'
import Widget from '../Widget/Widget';
import { getHash } from '../../utils/utils';

function Dashboard({ documentId }: { documentId: string }) {

    const genderOptions = ['male', 'female'];
    const ageOptions = [20, 30, 40, 50, 60, 70, 80, 90, 100];

    const panels = ['1', '2', '3', '4', '5'];

    const [filters, setFilters] = React.useState<any>({
        gender: 'male',
        age: 20,
    });

    const { client } = useVeltClient();

    useEffect(() => {
        setDocumentId();
    }, [documentId, client]);

    useEffect(() => {
        setLocation();
    }, [filters, documentId, client]);

    const setDocumentId = () => {
        if (client && documentId) {
            client?.setDocumentId(documentId);
        }
    };

    const setLocation = () => {
        if (client) {
            if (filters) {
                const location: any = {
                    id: getHash(JSON.stringify(filters)),
                    filters
                };
                // generate location name like gender: male, age: 20
                const locationName = `D${documentId}: Gender: ${filters?.gender}, Age: ${filters?.age}`;
                location.locationName = locationName;
                client?.setLocation(location);
            }
        }
    }

    return (
        <>
            <div className='d-flex flex-column gap-4'>
                {/* Filters ui */}
                {/* form with gender, age select option */}
                <form className='d-flex gap-2'>
                    <div>Gender: </div>
                    <select
                        onChange={(e) => {
                            setFilters({ ...filters, gender: e.target.value });
                        }}>
                        {
                            genderOptions.map((gender, index) => {
                                return <option key={index} value={gender}>{gender}</option>
                            })
                        }
                    </select>
                    <div>Age: </div>
                    <select
                        onChange={(e) => {
                            setFilters({ ...filters, age: +e.target.value });
                        }}>
                        {
                            ageOptions.map((age, index) => {
                                return <option key={index} value={age}>{age}</option>
                            })
                        }
                    </select>
                </form>

                <div className='d-flex gap-3 flex-wrap'>
                    {/* Widgets container  */}
                    {
                        panels.map((panelId, index) => {
                            return <Widget key={index} documentId={documentId} globalFilters={filters} panelId={panelId} />
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default Dashboard;